<template>
  <div>
    <v-row justify="start" align="center">
      <v-col cols="12">
        <v-banner icon="edit" v-if="selectedStandingOrder">
          <span>Creating</span>
           : {{selectedStandingOrder.trolly_header_info.name}} ({{selectedStandingOrder.id}})
          <template
            v-slot:actions
          >
            <v-btn text color="error" exact @click="deleteStandingDialog = true" v-if="!isEnabledOrReadOnly">
              <v-icon left>delete_forever</v-icon>Delete Standing Order
            </v-btn>
            <v-btn
              text
              color="blue darken-2"
              exact
              :to="{name: 'StandingOrderProducts'}"
            >
              <v-icon left>arrow_back</v-icon>Back
            </v-btn>
          </template>
        </v-banner>
      </v-col>
      

      <v-col md="12" sm="12">
        <StandingProgress :step="3"></StandingProgress>
      </v-col>
      <v-col cols="12" md="12">
        <SavedCardsSetting />
      </v-col>
      <!-- <v-col v-if="loadingItems" cols="12" lg="12" xs="12">
        <v-card class="mx-auto" outlined height="100%" loading>
          <v-card-title>Loading Products...</v-card-title>
          <template slot="progress">
            <v-progress-linear color="blue darken-2" indeterminate></v-progress-linear>
          </template>
        </v-card>
      </v-col>--->
      <v-col cols="12" md="12">
          <v-card flat>
              <v-card-title class="subtitle-2 font-weight-meduim">
                  Your saved card ending .. will be charged for this standing order. In case of payment failure, your order will not be dispatched
              </v-card-title>
                <v-card-actions>
                    <v-checkbox
                        v-model="agreeCheckBox"
                        label="I allow my card to be charged everytime this order is auto generated"
                        color="info"
                        hide-details
                    ></v-checkbox>
                </v-card-actions>
              <v-card-actions>
                  <v-spacer></v-spacer>
                   <v-col cols="12" md="6">
                       <v-btn
                      color="blue darken-2"
                      class="white--text"
                      block
                      large
                      :disabled="disableConfirm"
                      :loading = "loadingConfirm"
                    >
                      <span>Confirm Standing Order</span>
                    </v-btn>
                   </v-col>
                   <v-spacer></v-spacer>
              </v-card-actions>
          </v-card>
      </v-col>

      

      <v-dialog v-model="deleteStandingDialog" persistent max-width="400">
        <v-card>
          <v-toolbar color="background" flat dense>
            <v-toolbar-title>Delete Standing Order</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="deleteStandingDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-subtitle class="mt-4">
            Are you sure you want to delete standing order?
            <br />This action cannot be undone
          </v-card-subtitle>
          <v-divider />
          <v-card-actions>
            <v-btn text @click="deleteStandingDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="delStandingOrder()">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      
    </v-row>

    <!-- <v-bottom-navigation app fixed grow color="blue darken-2" class="hidden-lg-and-up">
      <v-btn @click="focusSearch()">
        <span>Search</span>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-btn :to="{name: 'StandingOrderGroups'}">
        <span>Groups</span>
        <v-icon>mdi-group</v-icon>
      </v-btn>

      <v-btn
        :loading="loadingFavourites"
        v-if="!$store.getters.retrieveGuest"
        @click="getFavouriteProducts()"
      >
        <span>Faves</span>
        <v-icon>mdi-heart</v-icon>
      </v-btn>

      <v-btn
        v-if="showPromotionsButton"
        :loading="loadingPromotions"
        @click="getPromotionalProducts()"
      >
        <span>Promos</span>
        <v-icon>mdi-sale</v-icon>
      </v-btn>

      <v-btn
        v-if="showNewProdsButton"
        :loading="loadingNewProducts"
        @click="getNewlyAvailableProducts()"
      >
        <span>New</span>
        <v-icon>fiber_new</v-icon>
      </v-btn>
    </v-bottom-navigation> -->
  </div>
</template>

<script>
import axios from "axios";
//import moment from "moment";
import { mapActions } from "vuex";
import StandingProgress from "@/components/order/standing/StandingProgress.vue";
import SavedCardsSetting from "@/components/payment/ManageSavedCards.vue";



export default {
  name: "StandingOrderConfirm",
  components: {
    StandingProgress,
    SavedCardsSetting
  },

  data() {
    return {
      currentTab: 0,
      loadingConfirm: false,
      deleteStandingDialog: false, 
      agreeCheckBox: null
    };
  },

  computed: {
    //  ...mapState(['standingOrderTrolly']),
    selectedStandingOrder() {
      if (this.$store.getters.retrieveCurrentStandingOrder) {
        return this.$store.getters.retrieveCurrentStandingOrder;
      }
      return false;
    },
    selectedStandingOrderDate() {
      if (this.selectedStandingOrder) {
        return this.selectedStandingOrder.trolly_header_info.order_date
      }

      return false
    },

    standingOrderIsActive() {
      if(this.selectedStandingOrder && this.selectedStandingOrder.enabled == 1) {
        return true
      } else {
        return false
      }
    },


    isEnabledOrReadOnly() {
      if (this.selectedStandingOrder.read_only == 1 || this.selectedStandingOrder.enabled == 1) {
        return true
      } 

      return false
    },

    isReadOnly() {
      return this.selectedStandingOrder.read_only == 1 && this.selectedStandingOrder.enabled != 1
    },

    isEnabledOnly() {
      return this.selectedStandingOrder.enabled == 1 && this.selectedStandingOrder.read_only != 1
    },
    
    totalBasketItems() {
      if (this.currentStandingTrolly) {
        return this.currentStandingTrolly.totalItems;
      } else {
        return false;
      }
    },

    totalQty() {
      if (this.currentStandingTrolly) {
        return this.currentStandingTrolly.totalQty;
      } else {
        return 0;
      }
    },

    basketItems() {
      if (this.totalBasketItems) {
        return this.currentStandingTrolly.trolly_items;
      } else {
        return false;
      }
    },

    basketTotal() {
      if (this.totalBasketItems) {
        return this.currentStandingTrolly.totalValue;
      } else {
        return false;
      }
    }, 

    

    currentStandingTrolly() {
      return this.$store.getters.retrieveStandingOrderTrolly;
    },

    disableConfirm() {
      if (!this.agreeCheckBox) {
        return true
      }
      return false
    },
    selectedDays() {
      if (this.$store.getters.retrieveStandingOrderRepeatDays.length > 0) {
        return this.$store.getters.retrieveStandingOrderRepeatDays
      } else {
        return false
      }
    },

    
  },

  methods: {
    ...mapActions([
      "getStandingOrderTrolly",
      "setSnackbar",
      "deleteStandingOrder",
      "enableStandingOrder",
      "getStandingOrder",
      "disableSO"
    ]),


    capitalizeString(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }, 

    async delStandingOrder() {
      console.log("Delete SO");

      let response = await this.deleteStandingOrder();

      if (response) {
        this.setSnackbar({ text: "Order Cancelled" });
        this.$router.push({ name: "StandingOrders" });
      } else {
        this.setSnackbar({
          color: "error",
          text: "Error cancelling order"
        });
      }

      this.deleteStandingDialog = false;
    },

    
    async confirmStandingOrder() {
      //only submit when agreecheckbox and defaultPaymentSource
      if (this.agreeCheckBox) {
          this.loadingConfirm = true
        console.log('Enabling standing order...')
        
        let enableResponse = await this.enableStandingOrder()
        console.log(enableResponse)
        if (enableResponse.success == true) {
            this.setSnackbar({ text: "Standing Order Activated" });
            this.loadingConfirm = false
            //go to standing orders page
            this.$router.push({ name: "StandingOrders" });
        } else {
            this.setSnackbar({
            color: "error",
            text: enableResponse.messages[0]
            });
            this.loadingConfirm = false
        }
      }
    },


    
  },
  
};
</script>

